var _g, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTermsConditionsFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.667 0h682.667c94.257 0 170.667 76.41 170.667 170.667v682.667c0 94.257-76.41 170.667-170.667 170.667h-682.667c-94.257 0-170.667-76.41-170.667-170.667v-682.667c0-94.257 76.41-170.667 170.667-170.667z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M512 202.667c-170.84 0-309.333 138.493-309.333 309.333 0 170.842 138.493 309.333 309.333 309.333 170.842 0 309.333-138.492 309.333-309.333 0-170.84-138.492-309.333-309.333-309.333zM138.667 512c0-206.186 167.147-373.333 373.333-373.333s373.333 167.147 373.333 373.333c0 206.187-167.147 373.333-373.333 373.333s-373.333-167.147-373.333-373.333z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M512 469.291c23.565 0 42.667 19.102 42.667 42.667v136.533c0 23.565-19.102 42.667-42.667 42.667s-42.667-19.102-42.667-42.667v-136.533c0-23.565 19.102-42.667 42.667-42.667z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M469.333 375.458c0-23.564 19.102-42.667 42.667-42.667h0.337c23.565 0 42.667 19.103 42.667 42.667s-19.102 42.667-42.667 42.667h-0.337c-23.565 0-42.667-19.102-42.667-42.667z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTermsConditionsFilled);
export default __webpack_public_path__ + "static/media/icon-terms-conditions-filled.3bd80675d325b86262705091d01756cd.svg";
export { ForwardRef as ReactComponent };